module.exports = __webpack_public_path__ + "img/dashboard.ec3fab4e.svg";